import React, { useRef, useState } from 'react';
import { FilterPod, TableComponents, SimpleDialog, ExportButton } from 'components';
import { toFilterVOS } from 'components/FilterPod';
import { enifyDateTime } from 'utility';
import { Grid, Box } from '@mui/material';
import { useExportFile } from 'hooks';
import { DelegationDetails, DetailPanel } from '../components';
import AssignedDelegationServices from '../services/AssignedDelegationServices';
import { columns, generateData } from './components/Columns';
import { useStyles } from '../../style';
import useCustomHook from './hooks';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction } from 'utility';
import axios from 'axios';
import {getExportAssignDeligationUrl} from 'URLs';


// TODO: Detail button is not responsive

// The most completed MaterialTable acroos the project (but with FilterPod component).
const AssignedDelegation = ({  currencyText }) => {
  // -- STATES --//
  const {
    loading,
    setLoading,
    filterParams,
    setFilterParams,
    activeDetailID,
    setActiveDetailID,
    counter,
    setCounter,
    filters,
    setFilters,
    page, setPage,
    size,
    setSize,
    emptyLabel,
    setEmptyLabel,
    dataDialog, setDataDialog,
    showDialog, setShowDialog,
  } = useCustomHook();

  // --HOOKS--//
  const tableRef = useRef();
  const classes = useStyles();
  const actionsList =
    getDynamicObjectAction([
      'accountDelegationOtherPage',
      'updateDelegationOtherPage',
      'exportDelegationOtherPage',
      'detailsDelegationOtherPage',
      'imprestDelegationReportBtn',
      'branchDelegationReportBtn'

    ])
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  const { downloadFile, isExporting } = useExportFile({
    url: getExportAssignDeligationUrl(),
    filename: 'assigned-delegations-report',
  });

  const getDelegations = async (query) => {
    try {
      setLoading(true);

      // Handle Order By
      let orderBy = [];
      let orderByName = null;

      switch (query?.orderBy?.title) {
        case 'تخصیص به':
          orderByName = 'نام و نام خانوادگی';
          break;
        case `به میزان - ${currencyText}`:
          orderByName = 'میزان';
          break;
        case `میزان مصرف - ${currencyText}`:
          orderByName = 'استفاده شده';
          break;
        case 'شروع':
          orderByName = 'زمان شروع';
          break;
        case 'انقضا':
          orderByName = 'زمان انقضا';
          break;
        case 'شارژ مجدد':
          orderBy = [
            {
              name: 'دوره',
              isDesc: query?.orderDirection === 'desc',
            },
            {
              name: 'تعداد شارژ مجدد',
              isDesc: query?.orderDirection === 'desc',
            },
          ];
          break;
        case 'وضعیت':
          orderByName = query?.orderBy?.title;
          break;

        default:
          break;
      }

      if (orderByName && orderBy.length === 0) {
        orderBy = [
          {
            name: orderByName,
            isDesc: query?.orderDirection === 'desc',
          },
        ];
      }

      const filter = toFilterVOS([...filters]);
      if (filter.length === 0 && counter === 0) {
        setEmptyLabel('در بازه زمانی موردنظر داده‌ای یافت نشد!');
      } else setEmptyLabel('داده‌ای یافت نشد!');
      setCounter((state) => ++state);

      const params = {
        page: query ? query?.pageNumber : page,
        size: query?.pageSize || size,
        startDate: enifyDateTime(filters[0]?.value?.start?.format('jYYYY/jMM/jDD HH:mm:ss')),
        endDate: enifyDateTime(filters[0]?.value?.end?.format('jYYYY/jMM/jDD HH:mm:ss')),
      };

      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };

      setFilterParams({ data, params });

      const res = await AssignedDelegationServices.getAssignedDelegation(data, params);

      let list = [];
      if (res.result.rows) {
        list = generateData(res.result.rows, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }

      setLoading(false);

      return {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res.result.totalCount,
      };
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const onChangeStatus = async (id, newStatus) => {
    try {
      setLoading(true); // لودینگ جدول است
      await AssignedDelegationServices.changeDelegationStatus(id, newStatus);
      setTimeout(() => { // بعد از دو ثانیه دیتای جدول رفرش میشود - علت این است دیتا سریع آبدیت نمیشود و اعلام شده 2 ثانیه تاخیر بزاریم
        tableRef?.current?.onChangeTable();
      }, 2000)
    } catch (error) { setLoading(false); }
  };

  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };

  const onExport = (type, index) => {
    const types = ['xls', 'csv'];
    downloadFile(types[index], filterParams?.data, filterParams?.params);
  };

  return (
    <div>
      <Grid item xs={12}>
        <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
          {(actionsList['accountDelegationOtherPage'] || actionsList['imprestDelegationReportBtn'] || actionsList['branchDelegationReportBtn']) && (

            <FilterButton
              setOpenFilterDialog={setOpenFilterDialog}
              filters={filters}
            />
          )}
          {actionsList['exportDelegationOtherPage'] && (

            <ExportButton
              loading={isExporting}
              types={['xls', 'csv']}
              onExport={onExport}
            />
          )}
        </Box>
        {(actionsList['accountDelegationOtherPage'] || actionsList['imprestDelegationReportBtn'] || actionsList['branchDelegationReportBtn']) && (

          <Box>
            <FilterPod
              filters={filters}
              onChange={onFiltersChange}
              openFilterDialog={openFilterDialog}
              setOpenFilterDialog={setOpenFilterDialog}
              handleCloseFilterDialog={handleCloseFilterDialog}
            />
          </Box>
        )}
      </Grid>
      {(actionsList['accountDelegationOtherPage'] || actionsList['imprestDelegationReportBtn'] || actionsList['branchDelegationReportBtn']) && (currencyText) && (
        <TableComponents
          data={getDelegations}
          columns={columns(setActiveDetailID, onChangeStatus, actionsList, classes, setShowDialog, setDataDialog , currencyText)}
          isLoading={loading}
          ref={tableRef}
          onChange={(ps) => {
            setPage(ps?.pageNumber)
            setSize(ps?.pageSize)
            return getDelegations(ps)
          }}
        />
      )}

      <SimpleDialog
        fullWidth
        maxWidth="md"
        open={showDialog}
        title={'جزئیات اعتبار تخصیص داده شده'}
        onClose={() => setShowDialog(false)}
      >
        <DetailPanel delegationId={dataDialog?.delegationId} />
      </SimpleDialog>

      <SimpleDialog
        fullWidth
        maxWidth="md"
        open={activeDetailID !== null}
        title="گزارش مصرف اعتبار اختصاصی"
        onClose={() => setActiveDetailID(null)}
      >
        <DelegationDetails delegationId={activeDetailID} />
      </SimpleDialog>
    </div>
  );
};

// See detail for every row


export default AssignedDelegation;
